"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var RemindersModel = /** @class */ (function () {
    function RemindersModel($http, APPURL) {
        var _this = this;
        this.cacheResults = function (result) {
            return _this.extract(result);
        };
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/schools",
            UPDATE: APPURL + "/api/v1/schools",
            CREATE: APPURL + "/api/v1/schools",
        };
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    RemindersModel.prototype.extract = function (result) {
        return result.data;
    };
    RemindersModel.prototype.getReminders = function (school_id, params) {
        if (params) {
            return this.$http
                .get(this.URLS.FETCH +
                "/" +
                school_id +
                "/reminders?" +
                (0, queryString_1.toQueryString)(params))
                .then(this.cacheResults);
        }
        return this.$http
            .get(this.URLS.FETCH + "/" + school_id + "/reminders")
            .then(this.cacheResults);
    };
    RemindersModel.prototype.deleteReminder = function (school_id, id) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + school_id + "/reminders/" + id)
            .then(this.cacheResults);
    };
    return RemindersModel;
}());
RemindersModel.$inject = ["$http", "APPURL"];
exports.default = RemindersModel;
